// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"5df09f4d","724":"dd4ad915"}[chunkId] + ".chunk.js";
};